import React from 'react';
import { connect } from 'react-redux';

import Carousel from '../../components/Carousel/Carousel';
import './Primary.css'

const primary = (props) => {
  let carouselBlock = <Carousel />
  let classes = 'relative margin-paragraph mt-5 p-5 sm:p-10 pt-5 bg-white rounded'
  if (!props.isHome) {
    carouselBlock = ''
    classes = 'relative margin-paragraph p-5 sm:p-10 pt-5 bg-white rounded'
  }

  return (
    <div className="col-start-1 col-end-7 lg:col-start-1 lg:col-end-5">
      {carouselBlock}
      <div className={classes}>
        {props.children}
      </div>
    </div>
  )
}


const mapsStateToProps = state => {
  return {
    isHome: state.isHome,
  }
}

export default connect(mapsStateToProps)(primary);
